import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../BaseUrl";
import { toastError, toastSuccess } from "../../../../Toast/Toast";


// insert / update
export const POST_M_SeminarMaster_InsertAPI = createAsyncThunk("POST_M_SeminarMaster_Insert", async ({ data }) => {
    const {
        SeminarID,
        Title,
        SubTitle,
        SelectDay,
        SeminarDate,
        StartTime,
        EndTime,
        Description,
        KeyTopics,
        FromDate,
        ToDate,
        SeminarPhotoPath,
        SeminarPhotoExt,
        SidePhotoPath,
        SidePhotoExt,
        RegisterLink,
        MeetingLink,
        M_UserID,
        token,
        handleIsPost,
        setloader,
        ScreenType,
    } = data

    var myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();

    if (ScreenType === "Update") {
        formdata.append("SeminarID", SeminarID);
    }
    formdata.append("Title", Title);
    formdata.append("SubTitle", SubTitle);
    formdata.append("SelectDay", SelectDay);
    formdata.append("SeminarDate", SeminarDate);
    formdata.append("StartTime", StartTime);
    formdata.append("EndTime", EndTime);
    formdata.append("Description", Description);
    formdata.append("KeyTopics", KeyTopics);
    formdata.append("FromDate", FromDate);
    formdata.append("ToDate", ToDate);

    if (SeminarPhotoPath instanceof File) {
        formdata.append("SeminarPhotoPath", SeminarPhotoPath, SeminarPhotoPath.name);
    } else if (SeminarPhotoPath) {
        formdata.append("SeminarPhotoPath", SeminarPhotoPath);
    }
    if (SeminarPhotoExt) {
        formdata.append("SeminarPhotoExt", SeminarPhotoExt);
    }
    if (SidePhotoPath instanceof File) {
        formdata.append("SidePhotoPath", SidePhotoPath, SidePhotoPath.name);
    } else if (SidePhotoPath) {
        formdata.append("SidePhotoPath", SidePhotoPath);
    }
    if (SidePhotoExt) {
        formdata.append("SidePhotoExt", SidePhotoExt);
    }

    formdata.append("RegisterLink", RegisterLink);
    formdata.append("MeetingLink", MeetingLink);
    formdata.append("M_UserID", M_UserID);

    const requestOptions = {
        method: ScreenType === "Update" ? "PATCH" : "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url =
        ScreenType === "Update"
            ? `${BaseUrl}/Master/M_SeminarMaster_Update`
            : `${BaseUrl}/Master/M_SeminarMaster_Insert`;

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error // keeps the thunk in the `rejected` case
        })
})

const POST_M_SeminarMaster_InsertSlice = createSlice({
    name: "POST_M_SeminarMaster_Insert",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(POST_M_SeminarMaster_InsertAPI.pending, (state) => {
            state.isPostLoading = true;
            state.isError = false;
        });
        builder.addCase(POST_M_SeminarMaster_InsertAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.isError = false;
            state.PostData = action.payload;
        });
        builder.addCase(POST_M_SeminarMaster_InsertAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
        });
    },
})

export const POST_M_SeminarMaster_InsertReducer = POST_M_SeminarMaster_InsertSlice.reducer


// delete
export const M_SeminarMaster_DeleteAPI = createAsyncThunk("M_SeminarMaster_Delete", async ({ data }) => {
    const {
        SeminarID,
        M_UserID,
        token,
        handleIsPost,
        setloader,
    } = data

    var myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();
    formdata.append("SeminarID", SeminarID);
    formdata.append("M_UserID", M_UserID);

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/M_SeminarMaster_Delete`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error
        })
})

const M_SeminarMaster_DeleteSlice = createSlice({
    name: "M_SeminarMaster_Delete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_SeminarMaster_DeleteAPI.pending, (state) => {
            state.isDeleteLoading = true;
            state.isError = false;
        });
        builder.addCase(M_SeminarMaster_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.isError = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(M_SeminarMaster_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;
        });
    },
})

export const M_SeminarMaster_DeleteReducer = M_SeminarMaster_DeleteSlice.reducer


// get data
export const GET_M_SeminarMaster_SelectAPI = createAsyncThunk("GET_M_SeminarMaster_Select", async ({ data }) => {
    const {
        SeminarID,
        SearchTerm,
        FromDate,
        ToDate, 
        Flag,
        M_UserID,
        Language,
        FromTop,
        ToTop,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/Get_M_SeminarMaster_Select?SeminarID=${SeminarID}&SearchTerm=${encodeURIComponent(SearchTerm ?? "")}&FromDate=${FromDate}&ToDate=${ToDate}&Flag=${Flag}&M_UserID=${M_UserID}&Language=${Language}&FromTop=${FromTop}&ToTop=${ToTop}`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                return result.data.table
            } else {
                return result
            }
        })
})

const GET_M_SeminarMaster_SelectSlice = createSlice({
    name: "GET_M_SeminarMaster_Select",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GET_M_SeminarMaster_SelectAPI.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(GET_M_SeminarMaster_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.TableData = action.payload;
        });
        builder.addCase(GET_M_SeminarMaster_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const GET_M_SeminarMaster_SelectReducer = GET_M_SeminarMaster_SelectSlice.reducer